"use strict";

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let loginTime = "";
let expirationTime = "";
const getExpirationTime = () => {
    if (localStorage.getItem("expired")) {
        loginTime = new Date();
        expirationTime = localStorage.getItem("expired").split(/[- :]/);
        expirationTime = new Date(expirationTime[0], expirationTime[1]-1, expirationTime[2], expirationTime[3], expirationTime[4], expirationTime[5]);
    }
};

const returnOfficesRoot = (to, from, next) => {
    getExpirationTime();
    if (localStorage.getItem("token") === null || expirationTime < loginTime || localStorage.getItem("role") !== "0") {
        return next({ "name": "offices_logout" });
    } 
    return next({ "name": "offices_delivery_destinations_list" });
};

const returnDriversRoot = (to, from, next) => {
    // getExpirationTime();
    // if (localStorage.getItem("token") === null || expirationTime < loginTime || localStorage.getItem("role") === "0") {
    //     return next({ "name": "drivers_logout" });
    // }
    return next({ "name": "drivers_delivery_destinations" });
};

const returnOfficesLogout = (to, from, next) => {
    getExpirationTime();
    if (localStorage.getItem("token") === null || expirationTime < loginTime || localStorage.getItem("role") !== "0") {
        return next({ "name": "offices_logout" });
    }
    return next();
};

const returnDriversLogout = (to, from, next) => {
    getExpirationTime();
    if (localStorage.getItem("token") === null || expirationTime < loginTime || localStorage.getItem("role") === "0") {
        return next({ "name": "drivers_logout" });
    }
    return next();
};

const router = new Router({
    "mode": "history",
    "base": process.env.BASE_URL,
    "routes": [
        {
            "path": "/",
            "name": "home",
            "redirect": { "name": "drivers_delivery_destinations" },
        },
        {
            "path": "/offices/drivers",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_drivers_list",
                    "component": () => import("./views/OfficesDriversList.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "create",
                    "name": "offices_drivers_create",
                    "component": () => import("./views/OfficesDriversDetail.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "update/:id",
                    "name": "offices_drivers_update",
                    "component": () => import("./views/OfficesDriversDetail.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
            ],
        },
        {
            "path": "/offices/vehicles",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_vehicles_list",
                    "component": () => import("./views/OfficesVehiclesList.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "create",
                    "name": "offices_vehicles_create",
                    "component": () => import("./views/OfficesVehiclesDetail.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "update/:id",
                    "name": "offices_vehicles_update",
                    "component": () => import("./views/OfficesVehiclesDetail.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
            ],
        },
        {
            "path": "/offices/delivery_destinations",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_delivery_destinations",
                    "redirect": { "name": "offices_delivery_destinations_create" },
                },
                {
                    "path": "create",
                    "name": "offices_delivery_destinations_create",
                    "component": () => import("./views/OfficesDeliveryDestinationsDetail.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "update/:id",
                    "name": "offices_delivery_destinations_update",
                    "component": () => import("./views/OfficesDeliveryDestinationsDetail.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
                {
                    "path": "recreate/:baseId",
                    "name": "offices_delivery_destinations_recreate",
                    "component": () => import("./views/OfficesDeliveryDestinationsDetail.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
            ],
        },
        {
            "path": "/offices/delivery_destinations_search",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_delivery_destinations_search",
                    "component": () => import("./views/OfficesDeliveryDestinationsSearch.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
            ],
        },
        {
            "path": "/offices/delivery_allocations",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_delivery_allocations",
                    "redirect": { "name": "offices_delivery_allocations_create" },
                },
                {
                    "path": "create",
                    "name": "offices_delivery_allocations_create",
                    "component": () => import("./views/OfficesDeliveryAllocationsCreate.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "update/:id",
                    "name": "offices_delivery_allocations_update",
                    "component": () => import("./views/OfficesDeliveryAllocationsUpdate.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
            ],
        },
        {
            "path": "/offices/delivery_allocations_list",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_delivery_allocations_list",
                    "component": () => import("./views/OfficesDeliveryAllocationsList.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
            ],
        },
        {
            "path": "/offices/daily_reports",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_daily_reports_list",
                    "component": () => import("./views/OfficesDailyReportsList.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "update/:id",
                    "name": "offices_daily_reports_update",
                    "component": () => import("./views/OfficesDeliveryAllocationsUpdate.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
            ],
        },
        {
            "path": "/offices/vehicle_inspections",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_vehicle_inspections_list",
                    "component": () => import("./views/OfficesVehicleInspectionsList.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "update/:id/:date",
                    "name": "offices_vehicle_inspections_update",
                    "component": () => import("./views/OfficesVehicleInspectionsUpdate.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
                {
                    "path": "update/month/:id/:month",
                    "name": "offices_vehicle_inspections_update_month",
                    "component": () => import("./views/OfficesVehicleInspectionsUpdateMonth.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
            ],
        },
        {
            "path": "/offices/work_times",
            "component": () => import("./layouts/Dashboard.vue"),
            "children": [
                {
                    "path": "",
                    "name": "offices_work_times_list",
                    "component": () => import("./views/OfficesWorkTimesList.vue"),
                    "beforeEnter": returnOfficesLogout,
                },
                {
                    "path": "update/:id/:date",
                    "name": "offices_work_times_update",
                    "component": () => import("./views/OfficesWorkTimesUpdate.vue"),
                    "beforeEnter": returnOfficesLogout,
                    "props": true,
                },
            ],
        },
        {
            "path": "/drivers/vehicle_inspection_dates/create/:id",
            "name": "drivers_vehicle_inspection_dates_create",
            "component": () => import("./views/DriversVehicleInspectionDatesCreate.vue"),
            "beforeEnter": returnDriversLogout,
            "props": true,
        },
        {
            "path": "/drivers/vehicle_inspection_months/create/:id",
            "name": "drivers_vehicle_inspection_months_create",
            "component": () => import("./views/DriversVehicleInspectionMonthsCreate.vue"),
            "beforeEnter": returnDriversLogout,
            "props": true,
        },
        {
            "path": "/drivers/delivery_destinations",
            "name": "drivers_delivery_destinations",
            "component": () => import("./views/DriversDeliveryDestinations.vue"),
            "beforeEnter": returnDriversLogout,
        },
        {
            "path": "/drivers/work_times",
            "name": "drivers_work_times",
            "component": () => import("./views/DriversWorkTimes.vue"),
            "beforeEnter": returnDriversLogout,
        },
        {
            "path": "/drivers/daily_reports",
            "name": "drivers_daily_reports",
            "component": () => import("./views/DriversDailyReports.vue"),
            "beforeEnter": returnDriversLogout,
        },
        {
            "path": "/offices/logout",
            "name": "offices_logout",
            "component": () => import("./layouts/OfficesLogOut.vue"),
            "meta": {
                "title": "Offices Log Out",
            },
        },
        {
            "path": "/offices/login",
            "name": "offices_login",
            "component": () => import("./layouts/OfficesLogIn.vue"),
            "meta": {
                "title": "Offices Log In",
            },
        },
        {
            "path": "/offices*",
            "beforeEnter": returnOfficesRoot,
        },
        {
            "path": "/drivers/logout",
            "name": "drivers_logout",
            "component": () => import("./layouts/DriversLogOut.vue"),
            "meta": {
                "title": "Drivers Log Out",
            },
        },
        {
            "path": "/drivers/login",
            "name": "drivers_login",
            "component": () => import("./layouts/DriversLogIn.vue"),
            "meta": {
                "title": "Drivers Log In",
            },
        },
        {
            "path": "/drivers*",
            "beforeEnter": returnDriversRoot,
        },
        {
            "path": "*",
            "beforeEnter": returnDriversRoot,
        },
    ],
    scrollBehavior() {
        return {
            "x": 0,
            "y": 0,
        };
    },
});

export default router;
